<template>
  <div>
    <v-row v-if="isLoading">
      <ProgressLinearLoaderVue :isLoading="isLoading" />
    </v-row>
    <v-row>
      <v-col
        v-for="ahu in filteredItems.length ? filteredItems : ChillersList"
        :key="ahu.controlId"
      >
        <!-- Chiller Card -->
        <ChillerCard :ChillerDevice="ahu" />
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, defineAsyncComponent } from 'vue';
import { useStore } from 'vuex';
import { searchByTermFactory } from '@/Core.Patterns/Factory';
import { sortAlphabetically } from '@/Core.Patterns/Strategy';

const ChillerCard = defineAsyncComponent(
  () =>
    import('@/Core.Service.Domain/Controls/Chillers/Components/ChillerCard.vue')
);

import { IChiller } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

import API from '@/Core.Service.Domain/Controls/Chillers/API';

import ProgressLinearLoaderVue from '@/Core.UI.Domain/Components/ProgressLinearLoader.vue';

const ChillersList = ref<IChiller[]>([]);
const isLoading = ref(true);

const emits = defineEmits(['update:ChillersList', 'update:isLoading']);

const store = useStore();
const defaultSite = computed(() => store.getters['session/defaultSite']);

onMounted(async () => {
  await loadChillers();
});

const searchTerm = computed(
  () => store.getters['ControlsStore/getControlSearchTerm']
);

const filteredItems = ref<IChiller[]>([]);

const loadChillers = async () => {
  isLoading.value = true;
  emits('update:isLoading', isLoading.value);
  try {
    ChillersList.value = await API.getChillersBySiteId(defaultSite.value.id);
    emits('update:ChillersList', ChillersList.value.length);
  } catch (error) {
    return Promise.reject(error);
  } finally {
    isLoading.value = false;
    emits('update:isLoading', isLoading.value);
  }
};

watch(searchTerm, () => {
  filteredItems.value = searchByTermFactory(
    searchTerm.value,
    ['controlName', 'controlFriendlyName', 'controlId', 'siteLocationName'],
    ChillersList.value
  );
});

watch(ChillersList, () => {
  filteredItems.value = sortAlphabetically(
    ChillersList.value,
    'controlFriendlyName'
  );
});

watch(defaultSite, () => {
  loadChillers();
});
</script>

<style lang="scss" scoped>
.v-col {
  flex-grow: 0;
}
</style>
